<template>
    <section class="weekly-updates">
        <div class="panel">
            <div class="panel-heading">
                <h2>Weekly Updates</h2>
            </div>
            <div class="panel-body" v-if="alerts">
                <ul class="alerts" v-if="!alerts.length">
                    <li><h3>No updates due.</h3></li>
                </ul>
                

                <ul class="alerts">
                    <li v-for="alert in alerts">

                        <!-- HEADING -->
                        <div class="heading" @click="toggleAlert(alert.id)">
                            <i
                                class="fa fa-check status-icon"
                                v-if="alert['weekly_update.id']">
                            </i>
                            <i
                                class="fa fa-times animated status-icon"
                                v-if="isOverdue(alert.dueDate) && !alert['weekly_update.id']">
                            </i>
                            <h3>Week {{alert.week}}</h3>
                            <span
                                class="status-extra status-extra-bad"
                                v-if="isOverdue(alert.dueDate) && !alert['weekly_update.id']">
                                Past Due
                            </span>
                            <span
                                class="status-extra"
                                v-if="!isOverdue(alert.dueDate) && !alert['weekly_update.id']">
                                Due
                            </span>
                            <span :title="formatFullDate(alert.dueDate)">
                                {{ formatShortDate(alert.dueDate) }}
                            </span>
                        </div>

                        <!-- BODY -->
                        <div class="form" v-if="openAlert === alert.id">

                            <!-- COMPLETED UPDATE -->
                            <div v-if="alert['weekly_update.id']" class="completed-update">
                                <div class="row">
                                    <div class="col-xs-3">Attended Session</div>
                                    <div class="col-xs-9">{{alert['weekly_update.attended'] === true ? 'Yes' : 'No'}}</div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-3">Live Session Experience</div>
                                    <div class="col-xs-9"><span v-if="alert['weekly_update.liveSessionExperience']">{{alert['weekly_update.liveSessionExperience'] | deslugify}}</span></div>
                                </div>
                                <div class="row" v-if="alert['weekly_update.liveSessionComments']">
                                    <div class="col-xs-3">Live Session Comments</div>
                                    <div class="col-xs-9">{{alert['weekly_update.liveSessionComments']}}</div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-3">Overall Experience</div>
                                    <div class="col-xs-9">{{alert['weekly_update.overallExperience'] | deslugify}}</div>
                                </div>
                                <div class="row" v-if="alert['weekly_update.overallComments']">
                                    <div class="col-xs-3">Overall Comments</div>
                                    <div class="col-xs-9">{{alert['weekly_update.overallComments']}}</div>
                                </div>
                                <div class="submission-date">
                                    Submitted on {{ formatFullDate(alert['weekly_update.updatedAt']) }}
                                </div>
                            </div>

                            <!-- NEW UPDATE -->
                            <div v-else>
                                <div class="form-group" v-if="isSupervisor">
                                    <label>Did the live session run?</label>
                                    <pre>{{alert}}</pre>
                                    <ul class="radio-wrapper supervisor">
                                        <li><label><span class="dot" :class="{'selected': alert.attended == 'yes'}"></span>Yes</label></li>
                                        <li><label><span class="dot" :class="{'selected': alert.attended == 'no'}"></span>No</label></li>
                                    </ul>
                                </div>

                                <div class="form-group" v-else>
                                    <label>Did you attend the live session?</label>
                                    <ul class="radio-wrapper">
                                        <li><label><input type="radio" name="attended[]" v-model="update.attended" value="yes"><span class="dot"></span>Yes</label></li>
                                        <li><label><input type="radio" name="attended[]" v-model="update.attended" value="no"><span class="dot"></span>No</label></li>
                                    </ul>
                                </div>

                                <div class="form-group" v-if="update.attended === 'no' || alert.attended === 'no'">
                                    <label>Why didn't you make it?</label>
                                    <div class="textarea-wrapper">
                                        <textarea
                                            class="form-control"
                                            v-model="update.missedAttendanceReason">
                                        </textarea>
                                    </div>
                                </div>
                                <div class="form-group" v-if="update.attended === 'yes' || alert.attended === 'yes'">
                                    <label>How did the live session go?</label>
                                    <ul class="radio-wrapper">
                                        <li v-for="status in statuses">
                                            <label>
                                                <input type="radio" v-model="update.liveSessionExperience" :value="status">
                                                <span class="dot"></span>
                                                {{status | deslugify}}
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-group" v-if="update.attended === 'yes' || alert.attended === 'yes'">
                                    <label>
                                        Is there anything you'd like to share with us about the session?
                                        <sup v-if="update.liveSessionExperience !== 'not_great'">(optional)</sup>
                                    </label>
                                    <div class="textarea-wrapper">
                                        <textarea
                                            class="form-control"
                                            v-model="update.liveSessionComments">
                                        </textarea>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>How are things going overall?</label>
                                    <ul class="radio-wrapper">
                                        <li v-for="status in statuses">
                                            <label>
                                                <input type="radio" v-model="update.overallExperience" :value="status">
                                                <span class="dot"></span>
                                                {{status | deslugify}}
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-group">
                                    <label>
                                        Is there anything on your mind that you'd like to share?
                                        <sup v-if="update.overallExperience !== 'not_great'">(optional)</sup>
                                    </label>
                                    <div class="textarea-wrapper">
                                        <textarea
                                            class="form-control"
                                            v-model="update.overallComments">
                                        </textarea>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button
                                        class="btn btn-success"
                                        :disabled="!!getNextStep(alert).field"
                                        :title="getNextStep(alert).message"
                                        @click.prevent="submitUpdate(alert)">
                                        Submit Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
import weeklyUpdates from '../services/weekly-updates';

import moment from 'moment';
import toastr from 'toastr';
import { clone } from 'underscore';

export default {
    data() {
        return {
            alerts: null,
            openAlert: null,
            statuses: [
                'excellent',
                'good',
                'meh',
                'not_great',
            ],
            update: {
                attended: null,
                missedAttendanceReason: null,
                liveSessionExperience: null,
                overallExperience: null,
                liveSessionComments: null,
                overallComments: null
            }
        }
    },
    mounted() {
        this.getAlerts();
        
    },
    methods: {
        toggleAlert(id) {
            if (this.openAlert === id) {
                this.openAlert = null;
            } else {
                this.openAlert = id;
                this.resetUpdate();
            }
        },
        resetUpdate() {
            this.update =  {
                attended: null,
                missedAttendanceReason: null,
                liveSessionExperience: null,
                overallExperience: null,
                liveSessionComments: null,
                overallComments: null
            }
        },
        isOverdue(d) {
            return new Date(d) < new Date();
        },

        getAlerts() {
            weeklyUpdates.getAlerts().then((response) => {
                const oneMonthAgo = moment().subtract(1, 'month').toDate();
                const alerts = response.data.alerts.filter((a)=>{
                    return a['weekly_update.attended'] === true || a['weekly_update.attended'] === false || new Date(a.startDate) > oneMonthAgo;
                });
                this.alerts = alerts;
            });
        },

        submitUpdate(alert) {
            if (!this.canSubmitUpdate(alert)) {
                toastr.error(this.getNextStep(alert).message);
                return false;
            }

            this.$store.dispatch('toggle',{type:'loading', boolean: true});

            let update = clone(this.update);
            update.alertId = alert.id;

            if (this.isSupervisor) {
                update.attended = alert.attended;
            }

            update.attended = update.attended === 'no' ? false : true;


            weeklyUpdates.submit(update).then((response)=> {
                if (response.data.success === true) {
                    toastr.success('Update submitted.');
                    this.getAlerts();
                    this.$bus.$emit('reloadAlerts');
                    this.resetUpdate();
                    this.openAlert = null;
                    this.$store.dispatch('toggle',{type:'loading', boolean: false});
                } else {
                    toastr.error('Error submitting update.');
                    this.$store.dispatch('toggle',{type:'loading', boolean: false});
                }
            });
        },

        canSubmitUpdate(alert) {
            return !this.getNextStep(alert).field;
        },

        getNextStep(alert) {
            function isFieldEmpty(str) {
                return !str || str.trim() === '';
            }

            const update = clone(this.update);

            let attended = update.attended;
            if (this.isSupervisor) {
                attended = alert.attended;
            }
            if (!attended) {
                return {
                    field: 'attended',
                    message: 'Please indicate whether you attended the live session or not.',
                };
            }
            attended = attended === 'no' ? false : true;

            if (!attended && isFieldEmpty(update.missedAttendanceReason)) {
                return {
                    field: 'missed-attendance-reason',
                    message: 'Please indicate why you missed the live session.',
                };
            }

            if (attended && !update.liveSessionExperience) {
                return {
                    field: 'live-session-experience',
                    message: 'Please indicate how your live session went.',
                };
            }

            if (update.liveSessionExperience === 'not_great' &&
                isFieldEmpty(update.liveSessionComments)) {
                return {
                    field: 'live-session-comments',
                    message: "Please share why the live session didn't go well.",
                };
            }

            if (!update.overallExperience) {
                return {
                    field: 'overall-experience',
                    message: 'Please indicate how things are going overall.',
                };
            }

            if (update.overallExperience === 'not_great' &&
                isFieldEmpty(update.overallComments)) {
                return {
                    field: 'overall-comments',
                    message: "Please share why your overall experience isn't going well.",
                };
            }

            return {
                field: null,
                message: 'Submit update.',
            };
        },

        formatShortDate(date) {
            return moment(date).format('MMM D [at] h:mma');
        },

        formatFullDate(date) {
            return moment(date).format('MMM D, YYYY [at] h:mma');
        },
    },
    computed: {
        isSupervisor() {
            return localStorage.roles.includes('Supervisor');
        },

        currentTerm() {
            return this.$store.getters.currentTerm;
        },
    }
}
</script>

<style lang="scss" scoped>
.status-icon {
    font-size: 20px;
    display: inline-block;
    width: 20px;

    &.fa-check {
        color: rgb(63, 235, 155);
        transform: translateX(-2px);
    }
    &.fa-times {
        color: red;
    }
    &.animated {
        animation-name: pulse;
        animation-duration: 1.2s;
        animation-fill-mode: both;
        animation-iteration-count: infinite;
    }
}

.status-extra {
    padding: 0 8px;
    background: #999;
    color: #222;
    margin-right: 10px;

    &.status-extra-bad {
        background: red;
        font-weight: bold;
    }
}

.alerts {
    margin: 20px;

    > li {
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }

        .heading {
            background: #363636;
            padding: 1rem 2rem;
            cursor: pointer;
            border-bottom: 4px solid #444;
            display: flex;
            align-items: center;
            position: relative;

            &:hover::before {
                content: '';
                position: absolute;
                top: 0;
                bottom: -4px; // account for bottom border
                left: 0;
                width: 3px;
                background-color: #33ccff;
            }

            h3 {
                color: #d0d0d0;
                font-size: 2.2rem;
                margin: 0 0 0 10px;
                flex: 1;
            }
        }
    }
}

.form {
    padding: 3rem 4rem;
    background: #2c2c2c;

    .textarea-wrapper {
        width: 100%;
        max-width: 600px;
        margin: 10px 0 25px;
        padding: 0 0 0 20px;
    }

    textarea.form-control {
        background: #222 !important;
        height: 8rem;
        border: none !important;
        padding: 1rem !important;
        &::-webkit-scrollbar {
            width: 10px;
        }
        &::scrollbar {
            width: 10px;
        }
    }
}

.completed-update {
    .row {
        margin-bottom: 10px;
    }

    .col-xs-3 {
        background: #363636;
        font-weight: bold;
        padding: 5px 15px;
    }

    .col-xs-9 {
        padding-top: 5px;
        padding-bottom: 5px;
        padding-right: 0;
    }

    .submission-date {
        margin-top: 20px;
        font-style: italic;
        color: #777;
    }
}

.radio-wrapper {
    margin: 6px 0 20px 20px;

    &.supervisor {
        label {
            pointer-events: none;
        }
    }

    label {
        cursor: pointer;
    }

    input {
        display: none;
    }

    input:checked+.dot {
        background: #33ccff;
        border-color: #33ccff;
    }
}

.dot {
    width: 14px;
    height: 14px;
    border: 1px solid #b0b0b0;
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
    position: relative;
    top: 2px;
    margin-right: .5rem;

    &.selected {
        background: #33ccff;
        border-color: #33ccff;
    }
}
</style>



// WEBPACK FOOTER //
// WeeklyUpdates.vue?65a28fc8